<template>
  <div class="sender d-flex flex-column py-4">
    <div class="col-12 mb-3">
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <a class="nav-link" :class="{ 'active': view == 'sender' }" href="javascript:;" @click="setView('sender')">Sender</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" :class="{ 'active': view == 'timer' }" href="javascript:;" @click="setView('timer')">Timer</a>
        </li>
      </ul>
    </div>

    <div class="d-flex flex-column flex-md-row" v-if="view == 'sender'">
      <div class="col-12 col-md-4">
        <form name="form" @submit.prevent="sendMessage">
          <div class="form-group">
            <label for="message">Message</label>
            <textarea name="message" id="message" v-model="message" class="form-control" rows="10"></textarea>
          </div>

          <div class="d-flex justify-content-between mt-3">
            <button type="submit" class="btn btn-lg btn-success">Send</button>
            <button type="button" class="btn btn-lg btn-danger" @click="clearMessage()">Clear</button>
          </div>
        </form>
      </div>
      <div class="col-12 col-md-8 mt-4 mt-md-0">
        <div class="embed-responsive embed-responsive-16by9">
          <div class="embed-responsive-item">
            <display :sender="true"></display>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex flex-column flex-md-row" v-if="view == 'timer'">
      <div class="col-12 col-md-4">
        <form name="form" @submit.prevent="setTimer">
          <div class="form-group">
            <label for="message">Time</label>
            <input type="text" name="time" id="time" v-model="timer.time" class="form-control">
            <small id="emailHelp" class="form-text text-muted">Use format HH:MM:SS</small>
          </div>

          <div class="d-flex justify-content-between mt-3">
            <button type="submit" class="btn btn-lg btn-success">Send/Reset</button>
            <button type="button" class="btn btn-lg btn-outline-secondary" @click="startTimer">
              <span class="text-success" v-if="timer.started">&check;</span> Start
            </button>
            <button type="button" class="btn btn-lg btn-outline-danger" @click="stopTimer">
              <span class="text-danger" v-if="!timer.started">&check;</span> Stop
            </button>
          </div>
        </form>

        <div class="custom-control custom-switch mt-3">
          <input type="checkbox" class="custom-control-input" id="customSwitch1" @change="toggleShowTimer" v-model="timer.showTimer">
          <label class="custom-control-label" for="customSwitch1">Show timer</label>
        </div>
      </div>
      <div class="col-12 col-md-8 mt-4 mt-md-0">
        <div class="embed-responsive embed-responsive-16by9">
          <div class="embed-responsive-item">
            <timer-display :sender="true"></timer-display>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { firebase } from "@/initializers/firebase"
  
  import Display from "@/components/display.vue"
  import TimerDisplay from "@/components/timer-display.vue"

  export default {
    name: "sender",
    components: { Display, TimerDisplay },
    data() {
      return {
        message: null,
        timer: null,
        view: "sender",
      }
    },
    methods: {
      setView(view) {
        this.view = view
      },

      // MESSAGE
      async sendMessage() {
        this.save(this.message)
      },
      clearMessage() {
        this.save(null)
      },
      async save(message) {
        await firebase.firestore().collection(`app`).doc("message").set({ text: message })
      },

      // TIMER
      async setTimer() {
        this.saveTimer(this.time)
      },
      clearTimer() {
        this.saveTimer(null)
      },
      async saveTimer(time) {
        await firebase.firestore().collection(`app`).doc("timer").update({ time: this.timer.time })
        await firebase.firestore().collection(`app`).doc("timer").update({ time: time })
      },
      async startTimer() {
        await firebase.firestore().collection(`app`).doc("timer").update({ started: true })
      },
      async stopTimer() {
        await firebase.firestore().collection(`app`).doc("timer").update({ started: false })
      },
      async toggleShowTimer() {
        await firebase.firestore().collection(`app`).doc("timer").update({ showTimer: this.timer.showTimer })
      }
    },
    async mounted() {
      let app = await firebase.firestore().collection(`app`)
      await this.$bind("timer", app.doc(`timer`))
    }
  }
</script>
